import Icon from '@icon/Icon';

const PlusIcon = (props) => {
  const { color, ...rest } = props;
  return (
    <Icon {...rest} viewBox="0 0 24 24">
      <path
        d="M12.5 18V6"
        stroke={color}
        strokeWidth="1.7"
        strokeLinecap="round"
      />
      <path
        d="M6.5 12L18.5 12"
        stroke={color}
        strokeWidth="1.7"
        strokeLinecap="round"
      />
    </Icon>
  );
};

export default PlusIcon;
